<template>
  <v-app :style="{ background: $vuetify.theme.themes.light.background }">
    <slot name="header"></slot>
    <v-container  v-if="!isVisible" :class="$vuetify.breakpoint.mdAndUp ? 'fixed-width' : ''" >
      <v-sheet
          color="`grey lighten-4"
          class="pa-3"
      >
        <v-skeleton-loader
          type="heading, list-item-two-line, card, card"
        ></v-skeleton-loader>
      </v-sheet>
    </v-container>
    <v-container v-else :class="$vuetify.breakpoint.mdAndUp ? 'fixed-width' : ''">
      <template v-if="$route.name === 'BuyStatus'">
        <template v-if="isHubi">
          <v-subheader class="text-h6 align-center pb-1 pl-0" style="color: #2c2c2c">
            お客様へのご対応のお願い
            <v-btn
              v-if="!hideLogoutButton"
                class="d-flex white--text ml-auto rounded-lg"
                color="#009098"
                @click="buyLogout"
            >
              ログアウト
            </v-btn>
          </v-subheader>
          <v-row  class="text-body-2 align-center pl-4 pb-4">
            {{ this.hubiMessage }}
          </v-row>
        </template>
        <v-alert
            border="left"
            colored-border
            type="error"
            elevation="2"
            v-if="isBankRegistrable"
            color="#a0330a"
        >
          <v-row>
            <v-col class="pa-0">
              口座登録： {{this.bankNoticeMessage}}
            </v-col>
            <v-col class="shrink pa-0">
              <v-btn v-if="isValueBooks" href="/bank/add"
                     small
              >{{ this.bankButtonLabel }}</v-btn>
              <v-btn v-else :to="{name: 'BankForm'}"
                     small
              >{{ this.bankButtonLabel }}</v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-alert
            border="left"
            colored-border
            type="error"
            elevation="2"
            v-if="isUploadRegistrable"
            color="#a0330a"
        >
          <v-row>
            <v-col class="pa-0">
              身分証登録： {{this.uploadNoticeMessage}}
            </v-col>
            <v-col class="shrink pa-0">
              <v-btn v-if="isValueBooks" href="/identity/upload"
                     small
              >{{ this.bankButtonLabel }}</v-btn>
              <v-btn v-else :to="{name: 'UploadIdentification'}"
                  small
              >{{ this.uploadButtonLabel }}</v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-divider v-if="isHubi" class="mb-12" style="border-color: transparent" />

        <v-subheader v-if="!hideLogoutButton && !isHubi" class="text-h6 align-center pb-2 pt-4 mb-2">
          <v-btn
                 class="d-flex white--text ml-auto rounded-lg"
                 color="#009098"
                 @click="buyLogout"
          >
            ログアウト
          </v-btn>
        </v-subheader>
      </template>
      <validation-observer ref="observer" v-slot="observerProps">
        <v-tabs :vertical="$vuetify.breakpoint.mdAndUp"
                show-arrows
                v-model="tab">
          <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" exact class="justify-center justify-md-start">
            {{ tab.tabLabel }}<v-icon v-if="(tab.id === 1 && isBankRegisterError) || (tab.id === 2 && isUploadRegisterError)" small color="#EF0B68">mdi-alert</v-icon>
          </v-tab>
          <v-tabs-items v-model="tab" :touchless="true">
            <v-tab-item v-for="tab of tabs" :key="tab.id" :value="tab.route">
              <router-view
                  :heading-bg-color="isCharibon || $vuetify.breakpoint.mdAndUp ? 'transparent' : 'accent3'"
                  :heading-text-color="isCharibon || $vuetify.breakpoint.mdAndUp ? 'primaryTextColor' : 'white'"
                  :is-heading-text-bold="isCharibon || $vuetify.breakpoint.mdAndUp"
                  :max-number-of-packages="maxNumberOfPackages"
                  @getAllState="getAllState"
                  :class="isCharibon ? 'charibon-tab-row' : 'tab-row'"
                  name="state"
                  :do-word-break="tab.viewName !== 'upload'"
              >
                <template v-if="isValueBooks" #title><span class="text-h6 font-weight-regular" style="color: #2c2c2c">買取サービスの進行状況</span></template>
              </router-view>
              <template v-if="!isValueBooks">
                <template v-if="$route.path === tab.route">
                  <template v-if="$route.path === routeResolve('UploadIdentification') && isUploadRegistrable">
                    <v-btn
                        class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pr-2"
                        color="#EF0B68"
                        max-width="240"
                        width="100%"
                        height="60"
                        :disabled="observerProps.invalid || isTwoClickProtect"
                        @click="tab.actionApi"
                    >
                      アップロードする
                    </v-btn>
                  </template>
                  <template v-if=" ($route.path === routeResolve('PickupPackagesReference') && isPickupDateChangeable) ||
                        (!isValueBooks && $route.path === routeResolve('AddressReference') && buyStateFormLabels.isAccountChangeable)">
                      <v-btn
                          class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pr-2"
                          :color="isCharibon ? 'secondary' : '#EF0B68'"
                          max-width="240"
                          width="100%"
                          height="60"
                          :disabled="observerProps.invalid"
                          @click.stop="tab.hasOwnProperty('startEditFormApi') ? tab.startEditFormApi() : $router.push(tab.formRoute)"
                      >
                        変更する
                      </v-btn>
                  </template>
                </template>
                <template v-if="$route.path === tab.formRoute">
                  <template v-if="$route.path === routeResolve('BankForm')" class="ma-0 mt-10">
                    <v-btn
                        v-if="isBankRegistrable"
                        class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pr-2"
                        color="#EF0B68"
                        max-width="240"
                        width="100%"
                        height="60"
                        :disabled="observerProps.invalid"
                        @click="tab.confirmApi"
                    >
                      確認する
                      <v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                  </template>
                  <v-row v-else class="ma-0 mt-10">
                    <v-col>
                      <v-btn
                          class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pl-2"
                          color="grey lighten-1"
                          width="120"
                          height="60"
                          :to="tab.route"
                      >
                        <v-icon left>mdi-chevron-left</v-icon>
                        戻る
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                          class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pr-2"
                          :color="isCharibon ? 'secondary' : '#EF0B68'"
                          max-width="240"
                          width="100%"
                          height="60"
                          :disabled="observerProps.invalid"
                          @click.stop="tab.hasOwnProperty('confirmApi') ? tab.confirmApi() : $router.push(tab.confirmRoute)"
                      >
                        確認する
                        <v-icon right>mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
                <template v-if="$route.path === tab.confirmRoute">
                  <template v-if="!isCharibon && $route.path === routeResolve('AddressConfirm') && isChangeName && (!isBankRegistrable || !isUploadRegistrable)" class="ma-0 mt-10">
                    <v-alert
                        outlined
                        text
                        type="warning"
                    >
                      お名前を変更すると、身分証と口座の再登録が必要になります。
                    </v-alert>
                  </template>
                  <v-row class="ma-0 mt-10">
                    <v-col>
                      <v-btn
                          class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pl-2"
                          color="grey lighten-1"
                          width="120"
                          height="60"
                          @click.stop="$router.push(tab.formRoute)"
                      >
                        <v-icon left>mdi-chevron-left</v-icon>
                        戻る
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                          :key="tab.id"
                          class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pr-2"
                          color="#EF0B68"
                          max-width="240"
                          width="100%"
                          height="60"
                          :disabled="isTwoClickProtect"
                          @click.stop="tab.actionApi"
                      >
                        登録する
                        <v-icon right>mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </template>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </validation-observer>
    </v-container>
    <!-- FIXME: コンポーネント化-->
    <v-dialog v-model="errorDialog"
              :fullscreen="$vuetify.breakpoint.smAndDown"
              :width="$vuetify.breakpoint.smAndDown? '100%': '600px'"
    >
      <v-card>
        <v-card-title class="lighten-2 py-4 justify-center">
          {{ errorDialogTitle }}
        </v-card-title>
        <v-card-text class="justify-center">
          処理に失敗しました。<br>
          お手数をお掛けしますが、時間を置いて再度お試しください。
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn @click="errorDialogClose">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIXME: コンポーネント化-->
    <v-dialog v-model="errorDialogForGet"
              :fullscreen="$vuetify.breakpoint.smAndDown"
              :width="$vuetify.breakpoint.smAndDown? '100%': '600px'"
              :persistent="true"
    >
      <v-card>
        <v-card-title class="text-h6">
          該当のデータがありません。
        </v-card-title>
        <v-card-text>
          <v-row>お客様の{{this.getTitleLabel}}情報が見つかりません。</v-row>
          <v-row>恐れ入りますが、{{this.getTitleLabel}}状況確認ログイン画面にて、再度メールアドレス、買取ナンバーを入力してください。</v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mx-auto" :to="{name: 'OfferInfoLogin'}">{{this.getTitleLabel}}状況確認ログイン画面へ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  name: "offer-info-status",
  components: {},
  props: {
    hideLogoutButton: {
      type: Boolean,
      default: false
    },
    buyNumber: {
      type: String,
      default: null,
    },
  },
  data(){
    return {
      tab: null,
      bankRoute: this.routeResolve('BankForm'),
      isBankRegistrable: false,
      uploadRoute:  this.routeResolve('UploadIdentification'),
      isUploadRegistrable: false,
      errorDialog: false,
      errorDialogTitle: null,
      errorDialogForGet: false,
      isHubi: false,
      hubiTitle: "",
      hubiMessage: "",
      bankNoticeMessage: "",
      uploadNoticeMessage: "",
      bankButtonLabel: "登録",
      uploadButtonLabel: "登録",
      isBankRegisterError: false,
      isUploadRegisterError: false,
      isVisible: false,
      isTwoClickProtect: false,
      maxNumberOfPackages: VueConfig.sell.maxNumberOfPackages,
    }
  },
  async created() {
    this.setPickupTimeOffset(null);
    this.setSiteCode(this.$siteCode);
    this.updateBuyFormItems({name: 'site_code', value: this.$siteCode});
    if(this.isValueBooks && this.buyNumber){
      await this.saveBuyNumberToSession();
    }
    const allData = await this.retrieveBuyAllState();
    await this.populateBuyState(allData.buyStateResults);
    await this.populatePickupPackages(allData.buyPickupStateResults);
    if(!this.isValueBooks){
      await this.populateAddress(allData.buyAddressResults);
    }
    if (!this.isCharibon) {
      await this.isIdentityState(allData.buyIdentityResults);
      await this.isBankState(allData.buyBankResults);
    }
    if(!this.isVaboo){
      await this.getAssessItems(allData.buyAssessItemsResults);
    }

    if (this.isVaboo) {
      this.maxNumberOfPackages = VueConfig.sell.maxNumberOfPackagesForVaboo;
    } else if (this.isCharibon) {
      const vboffice = this.$route.query.vboffice;
      if (vboffice == VueConfig.sell.VbOfficeCodeCharibon) {
        this.updateBuyFormItems({name: 'vbOfficeCode', value: vboffice});
        this.maxNumberOfPackages = VueConfig.sell.maxNumberOfPackagesForCharibonVbOffice;
      } else {
        this.maxNumberOfPackages = VueConfig.sell.maxNumberOfPackagesForCharibon;
      }
    }

    this.isVisible = true;
  },
  provide: function () {
    return {
      setErrors: this.observeSetErrors,
      routeResolve: this.routeResolve,
      getAllState: this.getAllState,
    }
  },
  computed: {
    ...mapGetters({
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
      getBuyStateFormItems: 'buyState/getFormItems',
      getBuyStateFormLabels: 'buyState/getFormLabels',
    }),
    buyFormItems() {
      return this.getBuyFormItems;
    },
    buyFormLabels() {
      return this.getBuyFormLabels;
    },
    buyStateFormLabels() {
      return this.getBuyStateFormLabels;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
    isVaboo() {
      return this.$siteCode === VueConfig.siteCode.vaboo;
    },
    isValueBooks() {
      return this.$siteCode === VueConfig.siteCode.valuebooks;
    },
    getTitleLabel() {
      return this.isCharibon ? "お申込み" : "買取";
    },
    tabs() {
      const labels = [];
      labels.push({
        id: 0,
        tabLabel: this.getTitleLabel + "状況",
        viewName: "status",
        route: this.routeResolve('BuyStatus'),
      });

      if (this.isVaboo) {
        labels.push({
          id: 1,
          tabLabel: this.smAndDown ? "口座": "銀行口座の登録",
          viewName: "bank",
          route: this.bankRoute,
          formRoute: this.routeResolve('BankForm'),
          confirmApi: this.confirmBank,
          confirmRoute: this.routeResolve('BankConfirm'),
          actionApi: this.saveBank
        });
        labels.push({
          id: 2,
          tabLabel: "身分証登録",
          viewName: "upload",
          route: this.uploadRoute,
          actionApi: this.moveIdentification
        });
      }

      if(!this.isValueBooks) {
        labels.push({
          id: 3,
          tabLabel: this.smAndDown ? "集荷先": "集荷先情報",
          viewName: "address",
          route: this.routeResolve('AddressReference'),
          formRoute: this.routeResolve('AddressForm'),
          confirmApi: this.confirmAddress,
          confirmRoute: this.routeResolve('AddressConfirm'),
          startEditFormApi: this.startEditAddress,
          actionApi: this.updateAddress
        });
      }

      labels.push({
        id: 4,
        tabLabel: "集荷箱数・集荷日時",
        viewName: "pickup",
        route: this.routeResolve('PickupPackagesReference'),
        formRoute: this.routeResolve('PickupPackagesForm'),
        confirmRoute: this.routeResolve('PickupPackagesConfirm'),
        startEditFormApi: this.startEditPickupPackages,
        actionApi: this.changePickupPackages
      });
      return labels;
    },
    isChangeName(){
      return !(this.buyStateFormLabels.firstname === this.buyFormItems.firstname &&
          this.buyStateFormLabels.lastname  === this.buyFormItems.lastname &&
          this.buyStateFormLabels.firstnameKatakana  === this.buyFormItems.firstnameKatakana &&
          this.buyStateFormLabels.lastnameKatakana  === this.buyFormItems.lastnameKatakana
      )
    },
    isPickupDateChangeable: {
      get() {
        return this.buyStateFormLabels.isPickupDateChangeable;
      },
      set(value) {
        this.updateBuyStateFormLabels({name: 'isPickupDateChangeable', value: value});
      }
    },
  },
  methods: {
    ...mapMutations({
      setSiteCode: 'buyState/setSiteCode',
      setPickupTimeOffset: 'buy/setPickupTimeOffset',
    }),
    ...mapActions({
      updateBuyFormItems: 'buy/updateFormItems',
      updateBuyFormItemsList: 'buy/updateFormItemsList',
      updateBuyFormLabels: 'buy/updateFormLabels',
      isValidatePickupTime: 'buy/isValidatePickupTime',
      updateBuyStateFormItems: 'buyState/updateFormItems',
      updateBuyStateFormLabels: 'buyState/updateFormLabels',
      updateBuyStateFormLabelsList: 'buyState/updateFormLabelsList',
      populatePickupPackages: 'buyState/populatePickupPackages',
      setPickupPackagesForm: 'buyState/setPickupPackagesForm',
      retrieveBuyState: 'buyState/retrieveBuyState',
      updatePickupPackages: 'buyState/updatePickupPackages',
      retrieveAddress: 'buyState/retrieveAddress',
      retrieveIdentityState: 'buyState/retrieveIdentityState',
      retrieveBankState: 'buyState/retrieveBankState',
    }),
    observeSetErrors(response){
      this.$refs.observer.setErrors(response);
    },
    observeSetErrorsByName(name, errorMessage) {
      let params = {};
      params[name] = errorMessage;
      this.$refs.observer.setErrors(params);
    },
    scrollBehavior(position) {
      this.$vuetify.goTo(position, {
        duration: 300,
        offset: window.innerHeight / 2,
        easing: 'easeInOutCubic'
      })
    },
    scrollTargetNode(name) {
      return this.$refs.observer.refs[name].$el;
    },
    observerErrorHandle(name, message) {
      this.observeSetErrorsByName(name, message);
      this.scrollBehavior(this.scrollTargetNode(name));
    },
    routeResolve(name) {

      if (
        (this.isCharibon || this.isCharibon === undefined) && (name === 'BankForm' || name === 'UploadIdentification') ||
        (this.isValueBooks || this.isValueBooks === undefined) && (name === 'BankForm' || name === 'UploadIdentification')
      ) {
        // チャリボンで定義してない画面は無視する（resolve実行時に警告ログが出力されるため）
        return null;
      }

      // base が定義されているとbaseが2重になってしまう /form/form/
      const route = this.$router.resolve({
        name: name,
      }).href
      if(this.$routerBase){
        const reg = new RegExp("^" + this.$routerBase);
        const url = route.replace(reg, "")
        return '/' + url
      } else {
        return route
      }
    },
    async getAllState(){
      // セッションで排他制御のためにカスタマーテーブルの更新日時を保持している。
      // どれか1つでも更新すると、そこに差異がでてセッションの情報に不整合が発生するため、再取得が必要
      // promise.all でとるとセッションの更新がうまくいかない場合あったため1つずつ実行
      const allData = await this.retrieveBuyAllState();
      await this.populateBuyState(allData.buyStateResults);
      await this.populatePickupPackages(allData.buyPickupStateResults);
      if(!this.isValueBooks){
        await this.populateAddress(allData.buyAddressResults);
      }
      if (!this.isCharibon) {
        await this.isIdentityState(allData.buyIdentityResults);
        await this.isBankState(allData.buyBankResults);
      }
      if(!this.isVaboo){
        await this.getAssessItems(allData.buyAssessItemsResults);
      }
    },
    // 集荷日変更フォームを表示する
    async startEditPickupPackages(){
      // 集荷日更新フォームクリア
      this.setPickupPackagesForm({
        boxcount: this.buyFormLabels.pickupPackagesBackup.boxcount,
        shukaYmd: this.buyFormLabels.pickupPackagesBackup.shukaYmd,
        timeCode: this.buyFormLabels.pickupPackagesBackup.timeCode,
        timeNm: this.buyFormLabels.pickupPackagesBackup.timeNm
      });
      this.$router.push({name: "PickupPackagesForm"});
    },
    // 集荷日更新処理
    async changePickupPackages(){
      this.isTwoClickProtect = true;
      // バリデーション
      this.setPickupTimeOffset(null);
      const result = await this.isValidatePickupTime();
      if(!result){
        this.isTwoClickProtect = false;
        this.$router.push({name: "PickupPackagesForm"});
        setTimeout(() => {
          this.$refs.observer.setErrors({"日にち": "ご指定の集荷希望日は選択できません。"})
        }, 500);
        return
      }

      const response = await this.updatePickupPackages();
      if (response) {
        await this.getAllState();  // セッションの排他制御用日付更新のため実行が必要
        this.isTwoClickProtect = false;
        this.$router.push({
          name: "PickupPackagesResultMessageCard",
          params: {
            backGroundColor: "accent2",
            title: "集荷日変更",
            subtitle: "集荷日の変更が完了しました。",
            text: "",
          }
        });
      } else {
        this.errorDialogTitle = "集荷日変更";
        this.errorDialog = true;
      }
      this.isTwoClickProtect = false;
    },

    // 買取状況取得
    async populateBuyState(buyStateResults){
      const response = await this.retrieveBuyState(buyStateResults);
      if(response){
        if (!this.isCharibon && response.hubi) {
          const hubi = response.hubi
          if(!hubi) {this.isHubi = false; return}
          // 同梱の場合 mibun は存在し、メッセージだけ残る場合があるため メッセージを初期化
          this.hubiMessage = "";
          this.hubiTitle = "";

          Object.keys(hubi).forEach(key => {
            switch (key) {
              case 'mibun':
                if(hubi.mibun) {
                  this.uploadNoticeMessage = hubi.mibun.message ? hubi.mibun.message: "";
                  this.uploadButtonLabel = hubi.mibun.unregist? "登録": "更新"
                  this.isUploadRegisterError = !hubi.mibun.unregist
                }
                break;
              case 'kouza':
                if(hubi.kouza) {
                  this.bankNoticeMessage = hubi.kouza.message ? hubi.kouza.message: "";
                  this.bankButtonLabel = hubi.kouza.unregist? "登録": "更新"
                  this.isBankRegisterError = !hubi.kouza.unregist
                }
                break;
              case 'common':
                if(hubi.common) {
                  this.isHubi = true
                  this.updateBuyStateFormLabels({name: 'isBuyStateWrong', value: true});
                  this.hubiMessage = hubi.common.message;
                  this.hubiTitle = hubi.common.title;
                }
                break;
              case 'D01':
                this.updateBuyStateFormLabels({name: 'buyStateNoticeMessage', value: hubi.D01.message1});
                this.updateBuyStateFormLabels({name: 'buyStateErrorMessage', value: hubi.D01.message2});
                break;
              default:
            }
          });
        }
      }
      if(response === false) {
        this.errorDialogHandle();
      }
    },

    // 銀行口座の登録状況確認
    async isBankState(buyBankResults){
      const response = await this.retrieveBankState(buyBankResults);
      if(!response.isErrorDialogForGet){
        this.isBankRegistrable = response.isBankRegistrable;
        if(this.isBankRegistrable){
          this.bankRoute = this.routeResolve('BankForm');
        }else{
          this.bankRoute = this.routeResolve('BankState');
        }
      } else {
        this.errorDialogHandle();
      }
    },
    // 銀行口座の入力情報をバリデーション
    async confirmBank(){
      const isValid = await this.$refs.observer.validate();
      if (isValid){
        this.$router.push({name: "BankConfirm"});
      } else {
        return false;
      }
    },
    // 銀行口座の登録処理
    async saveBank(){
      this.isTwoClickProtect = true;
      const response = await axios.post("/api/bank/save", {
        bank_code: this.buyFormItems.bankCode,
        bank_shiten: this.buyFormItems.branchCode,
        bank_kouza: this.buyFormItems.bankAccountNumber,
        bank_shubetu: this.buyFormItems.bankType,
        bank_meigi: this.buyFormItems.bankAccountName,
        yuucyo_kigou: this.buyFormItems.yuucyo_kigou,
        yuucyo_hansu: this.buyFormItems.yuucyo_hansu,
        yuucyo_kouza: this.buyFormItems.yuucyo_kouza,
        kouza_type: this.buyFormItems.kouza_type,
      }).catch((err) => { console.error("Catch" + err); return false; });

      if (response && response.data.result) {
        await this.getAllState();  // セッションの排他制御用日付更新のため実行が必要
        this.isTwoClickProtect = false;
        this.$router.push({
          name: "BankResultMessageCard",
          params: {
            backGroundColor: "accent2",
            title: "口座情報登録",
            subtitle: "口座登録完了",
            text: "口座情報の登録が完了しました。口座の情報の確認をさせていただきます。",
          }
        });
      } else {
        this.errorDialogTitle = "口座情報登録";
        this.errorDialog = true;
      }
      this.isTwoClickProtect = false;
    },

    // 本人確認書類の登録状況確認
    async isIdentityState(buyIdentityResults){
      const response = await this.retrieveIdentityState(buyIdentityResults);
      if(!response.isErrorDialogForGet){
        this.isUploadRegistrable = response.isUploadRegistrable;
        if(this.isUploadRegistrable){
          this.uploadRoute = this.routeResolve('UploadIdentification');
        }else{
          this.uploadRoute = this.routeResolve('UploadState');
        }
      } else {
        this.errorDialogHandle();
      }
    },
    // 本人確認書類の登録処理
    async moveIdentification(){
      this.isTwoClickProtect = true;
      const response = await axios.post("/api/identity/save", {
        youshi_code: this.buyFormItems.youshi_code,
        img_path1: this.buyFormItems.img_path1,
        img_path2: this.buyFormItems.img_path2,
      }).catch((err) => {
        console.error("Catch" + err);
      });
      if (response && response.data.result) {
        await this.getAllState();  // セッションの排他制御用日付更新のため実行が必要
        this.isTwoClickProtect = false;
        this.$router.push({
          name: "UploadResultMessageCard",
          params: {
            backGroundColor: "accent2",
            title: "身分証登録",
            subtitle: "アップロード完了",
            text: "ご協力ありがとうございます。ご本人様確認の手続きをさせていただきます。"
          }
        });
      } else {
        this.isTwoClickProtect = false;
        this.errorDialogTitle = "身分証登録";
        this.errorDialog = true;
      }
    },

    // 集荷先住所変更フォームの誕生日を設定する。引数は文字列YYYY-M-D
    setBirthdateForm(birthdateStr) {
      // FIXME: フォームの値を誕生日のみラベルで持っている(要LPリファクタ)
      const birthdateStrArr = birthdateStr.split('-');
      this.updateBuyFormLabels({name: 'birthdateYear', value: birthdateStrArr[0]})
      // 左側を0埋めする。そうしないと更新時にサーバー側検証で弾かれる。
      this.updateBuyFormLabels({name: 'birthdateMonth', value: birthdateStrArr[1].padStart(2, '0')})
      this.updateBuyFormLabels({name: 'birthdateDay', value: birthdateStrArr[2].padStart(2, '0')})
    },

    // 集荷先住所の取得
    async populateAddress(buyAddressResults){
      const response = await this.retrieveAddress(buyAddressResults);
      if(!response){
        this.errorDialogForGet = true;
      }
    },
    // 集荷先住所の検証
    async confirmAddress(){
      // 必要ならここにチェック処理を追加する
      this.$router.push({name: "AddressConfirm"});
    },
    // 集荷先住所変更フォームを開始する
    async startEditAddress(){
      // 集荷先住所変更フォームの値を戻す
      this.updateBuyFormItemsList(this.buyFormLabels.pickupAddressBackup);
      this.setBirthdateForm(this.buyFormItems.birthdate);

      this.$router.push({name: "AddressForm"});
    },
    // 集荷先住所の更新
    async updateAddress(){
      this.isTwoClickProtect = true;
      const response = await axios.post("/api/buy/state/address/save", {
        site_code: this.$siteCode,
        buyParams: this.getBuyFormItems,
      }).catch((err) => { console.error("Catch" + err); return false; });

      if (response && response.data.result) {
        await this.getAllState();  // セッションの排他制御用日付更新のため実行が必要
        this.isTwoClickProtect = false;
        this.$router.push({
          name: "AddressResultMessageCard",
          params: {
            backGroundColor: "accent2",
            title: "集荷先情報",
            subtitle: "集荷先情報の更新が完了しました。",
            text: "",
          }
        });
      } else {
        this.errorDialogTitle = "集荷先情報";
        this.errorDialog = true;
      }
      this.isTwoClickProtect = false;
    },

    // 買取明細の取得
    async getAssessItems(buyAssessItemsResults){
      if(buyAssessItemsResults){
        const data = buyAssessItemsResults;
        if(data) {
          this.updateBuyStateFormLabels({name: 'assessItems', value: data});
        }
      } else {
        this.errorDialogHandle();
      }
    },

    // 買取の全状況の取得
    async retrieveBuyAllState(){
      const response = await axios.get("/api/buy/allstate", {
        params: {
          site_code: this.$siteCode
        }
      }).catch((err) => {
        console.error("Catch" + err);
      });
      if(response && response.status === 200){
        return response.data;
      } else {
        this.errorDialogHandle();
      }
    },

    // 表示用に日付を整形する
    //文字列のYYYY-MM-DD HH:MM:SS がくる YYYY年MM月DD日にして返す
    convertedToDateStringForDisplay(dateString) {
      if (!dateString) return ""
      const date = new Date(dateString.replace(/-/g,"/"));
      if (!Number.isNaN(date.getTime())) {
        // return date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日"
        return date.toLocaleDateString('ja-JP', {
          weekday: 'short',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      }
      return ""
    },
    buyLogout(){
      axios.post( '/api/spot/logout' , {
        site_code: this.$siteCode
      }).then(response => {
        if(response.status === 200){
          this.$router.push({name: "OfferInfoLogin"});
        }
      }).catch(e => {
        console.error("Error: " + e)
      });
    },
    saveBuyNumberToSession() {
      return axios.post('/api/saveBuyNumberToSession', {
        site_code: this.$siteCode,
        buy_number: this.buyNumber,
      });
    },
    errorDialogClose(){
      if(this.isValueBooks) {
        location.href = "/mypage";
      } else {
        this.errorDialog = false;
      }
    },
    errorDialogHandle(){
      if(this.isValueBooks) {
        this.errorDialog = true;
      } else {
        this.errorDialogForGet = true;
      }
    },
  }
}
</script>

<style scoped lang="scss">
.fixed-width {
  max-width: 1024px;
}
.row {
  margin: 0;
}
.description {
  word-break: keep-all;
}

::v-deep {
  // pick up address
  .v-input {
    input {
      background-color: transparent;
      border: 0 none;
    }

    &--is-focused, &--is-dirty {
      .accent2 {
        background-color: white !important;
      }
    }
  }
  .row+.row {
    margin-top: 0 !important;
  }
}

@media screen and (max-width: $breakpoint-md) {
  ::v-deep {
    .v-tab {
      min-width: auto;
      padding: 0 8px;
    }
    .v-slide-group__next, .v-slide-group__prev {
      min-width: auto;
    }
    .charibon-tab-row {
      .row {
        margin: 0;
      }
    }
    .v-window {
      overflow: initial;
    }
  }
}

</style>